import { StatusCodes } from '@guiker/http'

import BaseError from './base-error'

export class UnauthorizedError extends BaseError {
  constructor({ userId }: { userId: string }) {
    super(`${userId} is not authorized`, 'UnauthorizedError', StatusCodes.FORBIDDEN)
  }
}
